import React from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { useText } from '../context/TextContext';

interface Props {
    activeDealsCount: number;
    planDealLimit: number;
}

const UsageSection: React.FC<Props> = (props: Props) => {
    const text = useText();

    const dealLimit = props.planDealLimit;
    const isUnlimited = dealLimit === -1;
    const usagePercent = !isUnlimited && dealLimit > 0 ? Math.min(100, Math.round((props.activeDealsCount / dealLimit) * 100)) : 0;

    return (
        <div className="d-flex flex-column gap-1 mb-2">
            <strong>{text.usageSectionHeader}</strong>
            <span>{text.usageSectionDescription}</span>
            <span>{`${props.activeDealsCount} / ${isUnlimited ? '∞' : dealLimit} (${isUnlimited ? text.unlimited : `${usagePercent}%`})`}</span>
            {!isUnlimited && dealLimit > 0 && (
                <ProgressBar
                    now={usagePercent}
                    striped
                    variant={props.activeDealsCount > dealLimit ? 'danger' : 'primary'}
                />
            )}
        </div>
    );
};

export default UsageSection;
